module.exports = __webpack_public_path__ + "img/curriculum.6023027b.png";